export default __webpack_public_path__ + "aa3ba84d535f1861ca2f1ad48227ea8a.png";